module.exports = __webpack_public_path__ + "img/hc_pro_two_8.503903c1.jpg";